<template>
    <section>
      <!-- Head page -->
      <div class="about">
        <span>We are more than an agency</span>
        <h1>About Us</h1>
      </div>
      <!-- About -->
      <v-container class="about-pic">
        <v-row style="align-items: center;">
          <v-col
            lg="4"
            md="4"
            sm="12"
            xs="12"
            class="no-col pad-0"
          >
            <div class="bg-shape">
              <img src="@/assets/images/about-3.jpg" alt="">
            </div>
          </v-col>
          <v-col
            lg="8"
            md="8"
            sm="12"
            xs="12"
            class="no-col"
            style="z-index: 1;"
          >
            <span class="big-title">About</span>
            <p>
              There are many variations of passages of Lorem Ipsum available, 
              but the majority have suffered alteration in some form, by injected humour,
              or randomised words which dont look even slightly believable. 
              If you are going to use a passage of Lorem Ipsum Ipsum available, 
              but the majority have suffered alteration in some form, by injected humour, 
              or randomised words which dont look even slightly believable. If you are going.
            </p>
            <v-row>
              <v-col lg="4" md="4" sm="12" xs="12" class="no-col">
                <span class="small-titre">Our Mission</span>
                <p>
                  luctus massa ipsum at tempus eleifend congue lectus bibendum
                </p>
              </v-col>
              <v-col lg="4" md="4" sm="12" xs="12" class="no-col">
                <span class="small-titre">Our Goals</span>
                <p>
                  luctus massa ipsum at tempus eleifend congue lectus bibendum
                </p>
              </v-col>
              <v-col lg="4" md="4" sm="12" xs="12" class="no-col">
                <span class="small-titre">Why Us?</span>
                <p>
                  luctus massa ipsum at tempus eleifend congue lectus bibendum
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <!-- Image divider -->
      <div class="divider">
        <span>
          Grow strong to take up the challenges of life. <br>
          The top lessons for getting you back on track.
        </span>
      </div>
      <!-- Our team -->
      <v-container>
        <v-row style="align-items: center;">
          <div class="heading">
            <span>WE ARE AWESOME</span>
            <h2>Our Team Members</h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
          </div>
        </v-row>
        <v-row style="align-items: center;">
          <v-col lg="3" md="3" sm="12" xs="12" class="no-col"  v-for="(team, i) in teams" :key="i">
            <TeamCard :loading="localLoading" :team="team">

            </TeamCard>
          </v-col>
        </v-row>
      </v-container>
    </section>
</template>

<script>
import TeamCard from "@/components/UI/TeamCard";
export default {
  components: {
    TeamCard
  },
  data: () => ({
    selected: [],
    teams: [
      {
        name: "Wael Manai",
        job: "UI/UX Designer",
        photoUrl: "about-3.jpg",
      },
      {
        name: "Wael Manai",
        job: "UI/UX Designer",
        photoUrl: "about-3.jpg",
      },
      {
        name: "Wael Manai",
        job: "UI/UX Designer",
        photoUrl: "about-3.jpg",
      },
      {
        name: "Wael Manai",
        job: "UI/UX Designer",
        photoUrl: "about-3.jpg",
      },
      {
        name: "Wael Manai",
        job: "UI/UX Designer",
        photoUrl: "about-3.jpg",
      },
      {
        name: "Wael Manai",
        job: "UI/UX Designer",
        photoUrl: "about-3.jpg",
      }
    ],
  }),
}
</script>

<style scoped>
.pad-0{
  padding: 0 !important;
}
.about{
    text-align: center;
    width: 100%;
    background-position: center;
    background-size: cover;
    position: relative;
    background-image: url("./../assets/bnr2.png") , linear-gradient(to right,#111c58 0,#5c2782 51%,#111c58 100%);
    display: grid;
    height: 300px;
    align-content: center;
    margin-bottom: 50px;
    background-attachment: fixed;
}
.about span{
    color: rgba(255, 255, 255, 0.6);
    display: block;
    margin-bottom: -15px;
}
.about h1{
    color: #fff;
    text-transform: uppercase;
    font-size: 48px;
    font-weight: 800;
}
.bg-shape:after, .bg-shape:before {
    content: '';
    position: absolute;
    height: 130px;
    width: 130px;
    z-index: 0;
}
.bg-shape:after {
    background: url("./../assets/images/shape-1.svg") no-repeat;
    background-size: auto;
    left: -55px;
    top: -55px;
}
.bg-shape:before {
    background: url("./../assets/images/shape-2.svg") no-repeat;
    background-size: auto;
    right: -55px;
    bottom: -55px;
}
.bg-shape{
    position: relative;
}
.bg-shape img{
    max-width: 85%;
    box-shadow: -20px 20px 35px #dcdcdc, 20px -40px 35px #fff;
    border-radius: 8px;
    position: relative;
    z-index: 5;
}
.about-pic .big-title{
    line-height: 1.4074;
    color: #1f1f25;
    font-weight: 700;
    font-size: 60px;
    margin-bottom: 8px;
}
.about-pic p{
    font-size: 18px;
    font-weight: 300;
    color: #717173;
    line-height: 30px;
}
.about-pic .small-titre{
    font-size: 30px;
    margin-bottom: 20px;
    font-weight: 500;
    line-height: 1.4074;
    color: #1f1f25;
    margin: 0 0 15px;
}

.divider{
  width: 100%;
  height: 300px;
  margin: 60px 0;
  display: grid;
  align-items: center;
  background: url("./../assets/images/about-us-01-hero-bg.jpg") no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  text-align: center;
}
.divider span{
  display: block;
  color: #fff;
  font-size: 34px;
  line-height: 48px;
  font-weight: 700;
}

.heading{
  width: 100%;
  text-align: center;
}
.heading span{
  color: #ed1f24;
  text-transform: uppercase;
  letter-spacing: .5px;
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 15px;
  display: block;
}
.heading h2{
  font-size: 40px;
  line-height: 52px;
  color: #1f1f25;
  font-weight: 600;
  margin-bottom: 15px;
}
.heading p{
  color: #6a6a8e;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
}
</style>